import { render } from "./InstructorCourses.vue?vue&type=template&id=2ef7b77f"
import script from "./InstructorCourses.vue?vue&type=script&lang=js"
export * from "./InstructorCourses.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__